import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LazyLoad from "react-lazy-load";

const PortfolioBigBox = ({ className, image, title, catName, viewMode = "grid" }) => {
  // List View Layout
  if (viewMode === "list") {
    return (
      <div
        className={`${className} group border-b border-gray-700/40 pb-8 cursor-pointer animate-fade-in-up`}
      >
        <Row className="!g-0">
          {/* Image on left */}
          <Col lg={5} className="!pe-6 lg:!pe-8">
            <div className="relative aspect-[4/3] w-full">
              <Card className="relative rounded-xl overflow-hidden bg-muted !border-0 !bg-transparent !h-full !w-full">
                <LazyLoad className="!h-full">
                  <Card.Img
                    src={image}
                    alt={title}
                    className="!w-full !h-full !object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </LazyLoad>
              </Card>
            </div>
          </Col>

          {/* Content on right */}
          <Col lg={7} className="!d-flex !flex-column !justify-content-center !align-items-start !my-auto">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-gray-500  backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full text-left">
                {catName}
              </div>
              {/* <span className="text-xs text-gray-400">2024</span> */}
            </div>

            <h3 className="text-2xl font-light text-white mb-3 group-hover:!text-[#FDCF00] transition-colors text-left">
              {title}
            </h3>

            <p className="text-gray-400 leading-relaxed mb-4 text-left">
              Building innovative digital solutions with modern design and cutting-edge technology.
            </p>

            <div className="flex items-center justify-between">
              <div className="flex flex-wrap gap-2">
                <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
                  Design
                </span>
                <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
                  Development
                </span>
                <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
                  UI/UX
                </span>
              </div>

              <svg
                className="w-5 h-5 text-gray-400 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-[#FDCF00]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M7 17L17 7M17 7H7M17 7V17"
                />
              </svg>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  // Grid View Layout (default)
  return (
    <div
      className={`${className} group !m-auto !w-full !max-w-[600px] cursor-pointer animate-fade-in-up`}
    >
      <Card className="relative aspect-[4/3] rounded-xl overflow-hidden bg-muted mb-6 !border-0 !bg-transparent">
        <LazyLoad className="!h-full">
          <Card.Img
            src={image}
            alt={title}
            className="!w-full !h-full !object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </LazyLoad>
        
        {/* Badge overlay on image */}
        <div className="absolute top-4 left-4">
          <div className="bg-black/60 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full">
            {catName}
          </div>
        </div>

        {/* Arrow icon on hover */}
        <div className="absolute top-4 right-4">
          <div className="w-8 h-8 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 17L17 7M17 7H7M17 7V17"
              />
            </svg>
          </div>
        </div>
      </Card>

      {/* Content below image */}
      <div className="space-y-3">
        <h3 className="text-xl font-light text-white group-hover:!text-[#FDCF00] transition-colors text-left">
          {title}
        </h3>

        <p className="text-gray-400 text-sm leading-relaxed line-clamp-2">
          Building innovative digital solutions with modern design and cutting-edge technology.
        </p>

        <div className="flex flex-wrap gap-2 pt-2">
          <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
            Design
          </span>
          <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
            Development
          </span>
          <span className="text-xs text-gray-500 bg-gray-800 px-2 py-1 rounded-md">
            UI/UX
          </span>
        </div>
      </div>
    </div>
  );
};

export default PortfolioBigBox;
